export default (state, level) => {
  state.vehicleLevel = level;
}
